export enum EnvironmentName {
	Development = "Development",
	Test = "Test",
	Preprod = "Preprod",
	Production = "Production"
}